import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

import general from '../../../modulos/general';
import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import selciudad from '../../../functions/selciudad';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

// "use strict";

//dropdown CLASES
const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoClaseServ} value={props.elemento._id} style={props.styles.input}>{props.elemento.descrClaseServ}</option>
  )
};

const Lista = ({styles, handleLista4, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="clase" id="miLista4" onChange={handleLista4} onClick={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todas...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CLASES

//dropdown RANGOS FACTURACION
const DetalleRangoNivel1 = props => {
    return (
      <option dato1={props.elemento._id} value={props.elemento.proxFact+':'+props.elemento.factInicial+':'+props.elemento.factFinal} style={props.styles.input}>{props.elemento.prefijo} {props.elemento.factInicial} - {props.elemento.factFinal}</option>
    )
  };
  
  const ListaRango = ({styles, list, handleChange}) => {
    const Nivel1Detalle = list.map((elemento, _id) => <DetalleRangoNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
    return(
      <div>
        <select style={styles.input} className="ui simple selection dropdown fluid" name="rango" id="miLista3" onChange={(ev)=>handleChange(ev)}>
          <option value="">Todos...</option>
          {Nivel1Detalle}
        </select>
      </div>
    )
  };
  //Fin dropdown RANGOS DE FACTURACION

//Lista de gestion recaudo
const FactDet = ({elemento, opciones, permiteOpcion1, permiteOpcion2, permiteOpcion3, permiteOpcion4}) => {
  if(((permiteOpcion1||permiteOpcion2)&&opciones==="opcion1"&&elemento.fechaNota!==undefined)||
      (elemento.fechaNota!==undefined&&elemento.fechaAjuste===undefined&&opciones==="opcion1")){
    return(
      <tr className=''>
      <td className=''>{elemento.fechaNota.substr(0, 10)}</td>
      <td className=''>{parseInt(elemento.numeroNota, 10)}</td>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.nombreCliente}</td>
      <td className=''>{elemento.apellidoCliente}</td>
      <td className=''>{elemento.numeroFra}</td>
      <td className=''>{elemento.usuarioCreate}</td>
      <td className=''>{elemento.observacNota}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorAntesImptos)}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorNota)}</td>
      </tr>
    )
  }
  if(((permiteOpcion1||permiteOpcion2)&&opciones==="opcion2"&&elemento.fechaNota!==undefined)||
      (elemento.fechaNota!==undefined&&elemento.fechaAjuste===undefined&&opciones==="opcion2")){
    return(
      <tr className=''>
      <td className=''>{elemento.fechaNota.substr(0, 10)}</td>
      <td className=''>{parseInt(elemento.numeroNota, 10)}</td>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.nombreCliente}</td>
      <td className=''>{elemento.apellidoCliente}</td>
      <td className=''>{elemento.numeroFra}</td>
      <td className=''>{elemento.usuarioCreate}</td>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorAntesImptos)}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorImptos)}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorTotal)}</td>
      </tr>
    )
  }
  if((((permiteOpcion3||permiteOpcion4)&&elemento.fechaAjuste!==undefined)||
      (elemento.fechaAjuste!==undefined&&elemento.fechaNota===undefined))&&opciones!=="opcion3"){
    return(
      <tr className=''>
      <td className=''>{elemento.fechaAjuste.substr(0, 10)}</td>
      <td className=''>{parseInt(elemento.numeroAjuste, 10)}</td>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.nombreCliente}</td>
      <td className=''>{elemento.apellidoCliente}</td>
      <td className=''>{elemento.usuarioCreate}</td>
      <td className=''>{elemento.concepto}</td>
      <td className='right aligned'>{Intl.NumberFormat('de-DE').format(elemento.valorAjuste)}</td>
      </tr>
    )
  }
  if((permiteOpcion1||permiteOpcion2)&&opciones==="opcion3"){
    // let valorImptos = parseInt(elemento.valorFacturado, 10) - parseInt(elemento.valorAntesImptos, 10)
    // if(permiteOpcion3||permiteOpcion4){
    //   valorImptos = 0
    // }
    return(
      <tr className=''>
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.codigoTipoDoc}</td>
        <td className=''>{elemento.numeroDoc}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.razonSocial}</td>
        <td className=''>{elemento.direccionCli}</td>
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.codigoDpto}</td>
        <td className=''>{elemento.codigoCiudad}</td>
        <td className=''>{elemento.descrClaseServ}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorAntesImptos.toString())}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorImptos.toString())}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorFacturado.toString())}</td>

      </tr>
    )
  }  
  if((permiteOpcion3||permiteOpcion4)&&opciones==="opcion3"){
    // let valorImptos = parseInt(elemento.valorFacturado, 10) - parseInt(elemento.valorAntesImptos, 10)
    // if(permiteOpcion3||permiteOpcion4){
    //   valorImptos = 0
    // }
    return(
      <tr className=''>
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.codigoTipoDoc}</td>
        <td className=''>{elemento.numeroDoc}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.razonSocial}</td>
        <td className=''>{elemento.direccionCli}</td>
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.codigoDpto}</td>
        <td className=''>{elemento.codigoCiudad}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorAntesImptos.toString())}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorImptos.toString())}</td>
        <td className='right aligned'>{general.formatNum(elemento.valorFacturado.toString())}</td>

      </tr>
    )
  }  
};

const ListaNotAju = ({list, opciones, permiteOpcion1, permiteOpcion2, permiteOpcion3, permiteOpcion4}) => {
  const nivel1Detalle = list.map((elemento, i) => <FactDet elemento={elemento} key={i} opciones={opciones}
                                  permiteOpcion1={permiteOpcion1} permiteOpcion2={permiteOpcion2}
                                  permiteOpcion3={permiteOpcion3} permiteOpcion4={permiteOpcion4}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//Fin lista de gestion recaudo


let fechaHoy = new Date()
let fechaIni = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-01'
fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

// const argsBuscarCL = {numDocum: 2027}
let argsBuscarNot = {tipoqry: `[{$match: {fechaNota: { $gte: new Date("2019-04-07"), $lte: new Date("2019-04-07") }}},{$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`}
let argsBuscarAju = {tipoqry: `[{$match: {fechaAjuste: { $gte: new Date("2019-04-07"), $lte: new Date("2019-04-07") }}},{$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`}

class RtesNotAju2 extends React.Component {
  state={argsDocum: {_id: "Todos...", desde: fechaIni, hasta: fechaHoy,
        descrDpto: "Todos...", nombreCiudad: "Todas..."},
        opciones: "opcion1", listRtes: [], confirmaAct: false, open: false, errors: [],
        totalNotAju: 0, totalNAValor: 0, argsSelDpto: this.props.argsSelDpto, verEnPantalla: false}

  handleChange = (ev) => {
    const argsDocum = this.state.argsDocum
// console.log(ev.target.name)
    if(ev.target.name==="opciones"){
      if(ev.target.checked===true){
        this.setState({opciones: ev.target.value})
      }
      let argsSelDpto = this.state.argsSelDpto
      argsSelDpto.descrClaseServ = "Todas..."
      this.setState({argsSelDpto})
    }else{
      if(ev.target.name === "rango"){
        var miLista = document.getElementById("miLista3");
        let _id = miLista.options[miLista.selectedIndex].attributes[0]?miLista.options[miLista.selectedIndex].attributes[0].value:""
        if(_id){
          argsDocum['_id'] = _id
        }else{
          argsDocum['_id'] = "Todos..."
        }
      }else{
        argsDocum[ev.target.name] = ev.target.value
      }
    }
// console.log(argsDocum)
    let listRtes = []
    this.setState({listRtes, totalNotAju: 0, totalNAValor: 0})
    this.setState({verEnPantalla: false})
    this.setState({argsDocum});
  }

  handleSubmit = async (ev, argsDocum, opciones)=>{
    // console.log(ev.target.name)
    // console.log(argsDocum)
    let targetName = ev.target.name
    document.body.style.cursor = 'wait'

    if(targetName==="pantalla"||targetName==="pdf"){
      this.setState({verEnPantalla: true})
    } 
    if((targetName==="pantalla"&&this.state.listRtes.length===0)||this.state.listRtes.length===0){
      let argsUpd
      let errors = []
      if(!this.props.allNotasDCRtes.allNotasDCRtes||!this.props.allAjusteRtes.allAjusteRtes){
        errors.push({path: "NotasAjustes", message: "Proceso de cargue de la información, por favor espere un momento..."});
      }
      if(!argsDocum.desde){
        errors.push({path: "Desde", message: "Debe seleccionar la fecha inicial de facturas causadas"});
      }
      if(!argsDocum.hasta){
        errors.push({path: "Hasta", message: "Debe seleccionar la fecha final de facturas causadas"});
      }
  // console.log(console.log(this.props.allNotasDCRtes.allNotasDCRtes))
    // console.log(argsDocum)
      this.setState({errors})
      if(errors.length===0){
        let argsBuscarNot="", argsBuscarAju=""
        let notasAjtes = []

        if(this.props.permiteOpcion1||this.props.permiteOpcion2){
          argsBuscarNot += `fechaNota: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
          if(argsDocum._id!=="Todos..."){
            argsBuscarNot += `, 'idRangoFact': '${argsDocum._id}'`
          }
          if(this.props.permiteOpcion1){
            argsBuscarNot += `, 'tipoNota': 'ND'`
          }else{
            argsBuscarNot += `, 'tipoNota': 'NC'`
          }
          argsBuscarNot = '{' + argsBuscarNot + '}'

          if(opciones==="opcion2"){
            //En el ultimo $project se pone _id: '$valorSF' para tener un _id unico
            //Si el _id no es unico => se repite el primer docummento
            argsBuscarNot = {tipoqry: `[{$match: ${argsBuscarNot}},
              {$unwind:"$detalleNota"},
              {$project: {fechaNota: 1, numeroNota: 1, contrato: 1, numeroFra: 1, usuarioCreate: 1,
                    'descrClaseServ': '$detalleNota.descrClaseServ',
                    'descripcionServicio': '$detalleNota.descripcionServicio',
                    'valorSF': {
                        $let: {
                            vars: {valorTipo: '$detalleNota.valor', tipo: '$detalleNota.tipo'},
                            in: { $cond: { if: { $eq: [ "$$tipo", "SF" ] }, then: "$$valorTipo", else: 0 } }
                        }
                    },
                    'valorIF': {
                        $let: {
                            vars: {valorTipo: '$detalleNota.valor', tipo: '$detalleNota.tipo'},
                            in: { $cond: { if: { $eq: [ "$$tipo", "IF" ] }, then: "$$valorTipo", else: 0 } }
                        }
                    }
                   }
              },
              {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
              {$unwind:"$cliente"},
              {$project: {fechaNota: 1, numeroNota: 1, contrato: 1, numeroFra: 1, usuarioCreate: 1,
                  nombreCliente: '$cliente.nombreCliente', apellidoCliente: '$cliente.apellidoCliente',
                  descrDpto: '$cliente.dirmayor.descrDpto', nombreCiudad: '$cliente.dirmayor.ciudades.nombreCiudad',
                  descripcionServicio: 1, descrClaseServ: 1, valorSF: 1, valorIF: 1}},
              {$group: {_id: {fechaNota: '$fechaNota', numeroNota: '$numeroNota', contrato: '$contrato', numeroFra: '$numeroFra',
                        usuarioCreate: '$usuarioCreate', nombreCliente: '$nombreCliente', apellidoCliente: '$apellidoCliente',
                        descrDpto: '$descrDpto', nombreCiudad: '$nombreCiudad',
                        descripcionServicio: '$descripcionServicio', descrClaseServ: '$descrClaseServ'},
                        valorSF: {$sum: '$valorSF'}, valorIF: {$sum: '$valorIF'}}},
              {$unwind:"$_id"},
              {$sort: {_id: 1}},
              {$project: {_id: {$concat: ['$_id.numeroNota', '$_id.numeroFra', '$_id.descripcionServicio']},
                        fechaNota: '$_id.fechaNota', numeroNota: '$_id.numeroNota', contrato: '$_id.contrato',
                        numeroFra: '$_id.numeroFra', usuarioCreate: '$_id.usuarioCreate',
                        nombreCliente: '$_id.nombreCliente', apellidoCliente: '$_id.apellidoCliente', descrDpto: '$_id.descrDpto',
                        nombreCiudad: '$_id.nombreCiudad', descrClaseServ: '$_id.descrClaseServ',
                        descripcionServicio: '$_id.descripcionServicio', valorAntesImptos: {$toInt: '$valorSF'}, valorImptos: {$toInt: '$valorIF'}}}
            ]`}
            
            let {data} = await this.props.allNotasDebCreRtes.refetch(argsBuscarNot)
            notasAjtes = await data.allNotasDebCreRtes
            console.log(notasAjtes)
          }else{
            if(opciones==="opcion3"){
              // console.log("11")
              let tipoqry = `[{$match: ${argsBuscarNot}},`
              argsBuscarNot = {tipoqry: `${tipoqry}
                {$unwind: "$detalleNota"},
                {$project: {contrato: 1, descrClaseServ: '$detalleNota.descrClaseServ',
                    valorAntesImptos: {
                        $let: {
                            vars: {valorTipo: '$detalleNota.valor', tipo: '$detalleNota.tipo'},
                            in: { $cond: { if: { $eq: [ "$$tipo", "SF" ] }, then: "$$valorTipo", else: 0 } }
                        }
                    },
                    valorIF: {
                        $let: {
                            vars: {valorTipo: '$detalleNota.valor', tipo: '$detalleNota.tipo'},
                            in: { $cond: { if: { $eq: [ "$$tipo", "IF" ] }, then: "$$valorTipo", else: 0 } }
                        }
                    }
                }},
                {$group: {_id: {contrato: '$contrato', descrClaseServ: '$descrClaseServ'},
                    valorAntesImptos: {$sum: '$valorAntesImptos'}, valorIF: {$sum: '$valorIF'}}},
                {$project: {_id: {$concat: ['$_id.contrato', '$_id.descrClaseServ']}, contrato: '$_id.contrato',
                    observacNota: '$_id.descrClaseServ',
                    valorAntesImptos: {$toInt: '$valorAntesImptos'}, valorNota: {$toInt: '$valorIF'}}},
                {$sort: {_id: 1}},
                {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}
              ]`}
            }else{
              argsBuscarNot = {tipoqry: `[{$match: ${argsBuscarNot}},{$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`}
            }
            // console.log(argsBuscarNot)
            let {data} = await this.props.allNotasDCRtes.refetch(argsBuscarNot)
            notasAjtes = await data.allNotasDCRtes
            // console.log(notasAjtes)
          }
        }else{
          argsBuscarAju += `fechaAjuste: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`        
          if(this.props.permiteOpcion3){
            argsBuscarAju += `, 'tipoAjuste': 'AP'`
          }else{
            argsBuscarAju += `, 'tipoAjuste': 'AN'`
          }
          argsBuscarAju = '{' + argsBuscarAju + '}'

          if(opciones==="opcion3"){
            let tipoqry = `[{$match: ${argsBuscarAju}},`
            argsBuscarAju = {tipoqry: `${tipoqry} {$group: {_id: "$contrato", valorAjuste: {$sum: "$valorAjuste"}}},{$sort: {_id: 1}},
              {$lookup: {from: 'clientes', localField: '_id', foreignField: 'contrato', as: 'cliente'}}
            ]`}
          }else{
            argsBuscarAju = {tipoqry: `[{$match: ${argsBuscarAju}},{$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`}
          }

          // console.log(argsBuscarAju)
          let {data} = await this.props.allAjusteRtes.refetch(argsBuscarAju)
          notasAjtes = await data.allAjusteRtes
        }
      // console.log(argsDocum._id)

      // console.log(notasAjtes)

// console.log(argsDocum)

      let listRtes = [], totalNotAju = 0, totalNAValor = 0
    // console.log(notasAjtes)
    // console.log(listRtes)
      let numeroNotaOp2 = 0
      let sumarNAOp2 = false
      notasAjtes.forEach((elemento, _id) => {
        if((this.props.permiteOpcion1||this.props.permiteOpcion2)&&opciones==="opcion2"){
          if((this.state.argsSelDpto.descrDpto===elemento.descrDpto||
              (!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."))&&
            (this.state.argsSelDpto.nombreCiudad===elemento.nombreCiudad||
              (!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."))){
                //slice => para extraer caracteres de la derecha
                argsUpd = {}
                if(this.state.argsSelDpto.descrClaseServ===elemento.descrClaseServ||
                    (!this.state.argsSelDpto.descrClaseServ||this.state.argsSelDpto.descrClaseServ==="Todas...")){                        
                  if(numeroNotaOp2!==elemento.numeroNota){
                    numeroNotaOp2 = elemento.numeroNota
                    sumarNAOp2 = true
                  }else{
                    sumarNAOp2 = false
                  }
                  totalNAValor += (parseInt(elemento.valorAntesImptos, 10) + parseInt(elemento.valorImptos, 10))
                  argsUpd = {}
                  argsUpd = {
                    "fechaNota": elemento.fechaNota,
                    "numeroNota": ('000000' + elemento.numeroNota).slice(-7),
                    "contrato": elemento.contrato,
                    "nombreCliente": elemento.nombreCliente,
                    "apellidoCliente": elemento.apellidoCliente,
                    "numeroFra": elemento.numeroFra,
                    "usuarioCreate": elemento.usuarioCreate,
                    "descrClaseServ": elemento.descrClaseServ,
                    "descripcionServicio": elemento.descripcionServicio,
                    "valorAntesImptos": elemento.valorAntesImptos,
                    "valorImptos": elemento.valorImptos,
                    "valorTotal": elemento.valorAntesImptos + elemento.valorImptos,
                  }
                  listRtes.push(argsUpd)
                }else{
                  sumarNAOp2 = false
                }
                listRtes = _.orderBy(listRtes, ['fechaNota', 'numeroNota'], ['asc', 'asc'])
                if(sumarNAOp2){totalNotAju += 1}
              }
        }else{
          if(elemento.cliente.length>0&&
            (this.state.argsSelDpto.descrDpto===elemento.cliente[0].dirmayor.descrDpto||
              (!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."))&&
            (this.state.argsSelDpto.nombreCiudad===elemento.cliente[0].dirmayor.ciudades.nombreCiudad||
              (!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."))){
            // if(this.state.argsSelDpto.descrDpto===elemento.cliente[0].dirmayor.descrDpto||
            //   (!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos...")){
            //     if(this.state.argsSelDpto.nombreCiudad===elemento.cliente[0].dirmayor.ciudades.nombreCiudad||
            //       (!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas...")){
  
              if(opciones!=="opcion3"){
                let nombreCliente = "", apellidoCliente = ""
                if(elemento.cliente.length>0){
                  nombreCliente = elemento.cliente[0].nombreCliente
                  apellidoCliente = elemento.cliente[0].apellidoCliente
                }
                //slice => para extraer caracteres de la derecha
                let sumarNA = false
                argsUpd = {}
                if(this.props.permiteOpcion1||this.props.permiteOpcion2){
                  sumarNA = true
                  totalNAValor += elemento.valorNota
                  argsUpd = {
                    "fechaNota": elemento.fechaNota,
                    "numeroNota": ('000000' + elemento.numeroNota).slice(-7),
                    "contrato": elemento.contrato,
                    "nombreCliente": nombreCliente,
                    "apellidoCliente": apellidoCliente,
                    "numeroFra": elemento.numeroFra,
                    "usuarioCreate": elemento.usuarioCreate,
                    "valorAntesImptos": elemento.valorAntesImptos,
                    "valorNota": elemento.valorNota,
                    "observacNota": elemento.observacNota,
                  }
                  listRtes.push(argsUpd)
                  listRtes = _.orderBy(listRtes, ['fechaNota', 'numeroNota'], ['asc', 'asc'])
                }else{
                  sumarNA = true
                  totalNAValor += elemento.valorAjuste
                  argsUpd = {}
                  argsUpd = {
                    "fechaAjuste": elemento.fechaAjuste,
                    "numeroAjuste": ('000000' + elemento.numeroAjuste).slice(-7),
                    "contrato": elemento.contrato,
                    "nombreCliente": nombreCliente,
                    "apellidoCliente": apellidoCliente,
                    "usuarioCreate": elemento.usuarioCreate,
                    "concepto": elemento.concepto,
                    "valorAjuste": elemento.valorAjuste,
                  }
                  listRtes.push(argsUpd)
                  listRtes = _.orderBy(listRtes, ['fechaAjuste', 'numeroAjuste'], ['asc', 'asc'])
                }
                if(sumarNA){totalNotAju += 1}
              }
              if(opciones==="opcion3"){
                // console.log("22")
                //TOTAL POR CONTRATO
                let direccionCli = ""
                // console.log(elemento)
                if(elemento.cliente[0].direccion&&elemento.cliente[0].direccion.descrTipoVia1){
                  direccionCli = elemento.cliente[0].direccion.descrTipoVia1?elemento.cliente[0].direccion.descrTipoVia1:""
                  direccionCli += elemento.cliente[0].direccion.numeroTipoVia1?" " + elemento.cliente[0].direccion.numeroTipoVia1:""
                  direccionCli += elemento.cliente[0].direccion.descrTipoVia2?" " + elemento.cliente[0].direccion.descrTipoVia2:""
                  direccionCli += elemento.cliente[0].direccion.numeroTipoVia2?" " + elemento.cliente[0].direccion.numeroTipoVia2:""
                  direccionCli += elemento.cliente[0].direccion.numeroTipoVia2F?" " + elemento.cliente[0].direccion.numeroTipoVia2F:""
                  direccionCli += elemento.cliente[0].direccion.descrTipoUnd1?" " + elemento.cliente[0].direccion.descrTipoUnd1:""
                  direccionCli += elemento.cliente[0].direccion.numeroTipoUnd1?" " + elemento.cliente[0].direccion.numeroTipoUnd1:""
                  direccionCli += elemento.cliente[0].direccion.descrTipoUnd2?" " + elemento.cliente[0].direccion.descrTipoUnd2:""
                  direccionCli += elemento.cliente[0].direccion.numeroTipoUnd2?" " + elemento.cliente[0].direccion.numeroTipoUnd2:""
                }
                let razonSocial = elemento.cliente[0].nombreCliente + " " + elemento.cliente[0].apellidoCliente
                let descrClaseServ = (this.props.permiteOpcion1||this.props.permiteOpcion2)?elemento.observacNota:""
                let valorAntesImptos = (this.props.permiteOpcion1||this.props.permiteOpcion2)?elemento.valorAntesImptos:elemento.valorAjuste
                let valorImptos = (this.props.permiteOpcion1||this.props.permiteOpcion2)?elemento.valorNota:0
                let valorFacturado = (this.props.permiteOpcion1||this.props.permiteOpcion2)?elemento.valorAntesImptos + elemento.valorNota:elemento.valorAjuste
                argsUpd = {}
                argsUpd = {
                  "contrato": elemento.cliente[0].contrato,
                  "codigoTipoDoc": elemento.cliente[0].tipodoc.codigoTipoDoc,
                  "numeroDoc": elemento.cliente[0].numeroDoc,
                  "apellidoCliente": elemento.cliente[0].apellidoCliente,
                  "nombreCliente": elemento.cliente[0].nombreCliente,
                  "razonSocial": razonSocial,
                  "direccionCli": direccionCli,
                  "nombreBarrio": elemento.cliente[0].dirmayor&&elemento.cliente[0].dirmayor.codigoDpto?elemento.cliente[0].dirmayor.ciudades.zonas.barrios.nombreBarrio:"",
                  "codigoDpto": elemento.cliente[0].dirmayor&&elemento.cliente[0].dirmayor.codigoDpto?elemento.cliente[0].dirmayor.codigoDpto:"",
                  "codigoCiudad": elemento.cliente[0].dirmayor&&elemento.cliente[0].dirmayor.codigoDpto?elemento.cliente[0].dirmayor.ciudades.codigoCiudad:"",
                  "descrClaseServ": descrClaseServ,
                  "valorAntesImptos": valorAntesImptos,
                  "valorImptos": valorImptos,
                  "valorFacturado": valorFacturado,
                }
                totalNAValor += valorFacturado

                listRtes.push(argsUpd)
              }
            }              
          }
        })
        // console.log(listRtes)
        this.setState({listRtes, totalNotAju, totalNAValor})
      }
    }
    // console.log(targetName)
    // console.log(this.props.permiteOpcion2)

    if(targetName==="pdf"){
      // console.log(this.state.listRtes)
      let totNotAju = 0, totAINot = 0
      this.state.listRtes.forEach((elemento, _id) => {
        if(this.props.permiteOpcion3||this.props.permiteOpcion4){
          totNotAju += elemento.valorAjuste
        }else{
          if(opciones==="opcion2"){
            totNotAju += (elemento.valorAntesImptos+elemento.valorImptos)
            totAINot += elemento.valorAntesImptos          
          }else{
            totNotAju += elemento.valorNota
            totAINot += elemento.valorAntesImptos          
          }
        }
      })

      var doc = new jsPDF({orientation: 'l', unit: 'mm', format: 'letter'})
      doc.setFontSize(14);
      doc.setFontType("bold");
      let texto1 = this.props.empresa.empresaRazonSocial
      let texto2 = ""
      if(this.props.permiteOpcion1){texto2 = "NOTAS DEBITO"}
      if(this.props.permiteOpcion2){texto2 = "NOTAS CREDITO"}
      if(this.props.permiteOpcion3){texto2 = "AJUSTES POSITIVOS"}
      if(this.props.permiteOpcion4){texto2 = "AJUSTES NEGATIVOS"}

      if(((this.props.permiteOpcion1||this.props.permiteOpcion2)&&opciones==="opcion2")&&
          this.state.argsSelDpto.descrClaseServ&&this.state.argsSelDpto.descrClaseServ!=="Todas..."){
        texto2 += " - " + this.state.argsSelDpto.descrClaseServ
      }

      // const fechaHoy = new Date()
      // let agnoHoy = fechaHoy.getFullYear()
      // let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
      // mesHoy = agnoHoy + "-" + mesHoy
      // let mesMsg = ""
      // argsDocum.mes?mesMsg=argsDocum.mes:mesMsg=mesHoy
      let tit1Texto3 = argsDocum.desde
      let tit2Texto3 = argsDocum.hasta
      let texto3 = `${tit1Texto3} - ${tit2Texto3}`
      // let texto3 = ""
      // doc.text(texto1, 108, 20, 'center')
      // doc.setFontSize(12);
      // doc.text(texto2, 108, 30, 'center')
      // doc.setFontSize(10);
      // doc.text(texto3, 108, 40, 'center')
  
      let widthDoc = (doc.internal.pageSize.width)
      doc.setFontSize(18);
      doc.setFontType("bold");
      doc.text(texto1, widthDoc/2, 20, 'center')
      doc.setFontSize(14);
      doc.text(texto2, widthDoc/2, 30, 'center')
      doc.text(texto3, widthDoc/2, 40, 'center')
      doc.setFontSize(10);

      if(opciones==="opcion1"){
        let movColecc = []
        let argsUpd = {}

        this.state.listRtes.forEach((elemento, i) => {
          if(this.props.permiteOpcion3||this.props.permiteOpcion4){
            argsUpd = [elemento.fechaAjuste.substr(0, 10), elemento.numeroAjuste, elemento.contrato,
              elemento.nombreCliente, elemento.apellidoCliente, elemento.usuarioCreate, elemento.concepto,
              general.formatNum(elemento.valorAjuste.toString())]
          }else{
            argsUpd = [elemento.fechaNota.substr(0, 10), elemento.numeroNota, elemento.contrato, elemento.nombreCliente,
              elemento.apellidoCliente, elemento.numeroFra, elemento.usuarioCreate, elemento.observacNota,
              general.formatNum(elemento.valorAntesImptos.toString()),
              general.formatNum(elemento.valorNota.toString())]
          }

          movColecc.push(argsUpd)
        })
        let encab
        if(this.props.permiteOpcion3||this.props.permiteOpcion4){
          argsUpd = ["", "", "", "", "", "", "TOTALES:",
            general.formatNum(totNotAju.toString())]

          encab = ["Fecha Ajuste", "# Ajuste", "Contrato", "Nombre", "Apellido", "Creada por", "Concepto",
            {content: "$ Valor", styles: {halign: "right"}}]
        }else{
          argsUpd = ["", "", "", "", "", "", "", "TOTALES:",
            general.formatNum(totAINot.toString()),
            general.formatNum(totNotAju.toString())]

          encab = ["Fecha Nota", "# Nota", "Contrato", "Nombre", "Apellido", "# Factura", "Creada por", "Observación",
            {content: "$ antes imptos", styles: {halign: "right"}},
            {content: "$ Total nota", styles: {halign: "right"}}]
        }
        movColecc.push(argsUpd)

        doc.autoTable({startY: 45,
          tableLineColor: "blue",
          tableLineWidth: 0.1,
          styles: {
            // font: 'Calibri',
            fontSize: 9,
            lineColor: "black",
            lineWidth: 0.1
          },
          headStyles: {
            fillColor: "#bdc3c7",
            textColor: "black",
            fontSize: 9
          },
          bodyStyles: {
            fillColor: "#E9E4F0",
            textColor: "black"
          },
          alternateRowStyles: {
            fillColor: "white",
            textColor: "black"
          },
          columnStyles: 
          (this.props.permiteOpcion3||this.props.permiteOpcion4)?
          {
            0: {cellWidth: 20},
            1: {cellWidth: 16},
            2: {cellWidth: 15},
            7: {cellWidth: 20, halign: "right"},
          }:
          {
            0: {cellWidth: 20},
            1: {cellWidth: 16},
            2: {cellWidth: 15},
            8: {cellWidth: 20, halign: "right"},
            9: {cellWidth: 20, halign: "right"},
          },
          footStyles: {
            fillColor: "#bdc3c7",
            textColor: "black",
            fontSize: 9
          },
          head: [encab],
          body: movColecc,
          margin: {top: 10, left: 2, right: 2}
        })
      }else{
        var source = document.getElementById("tabla");
        doc.autoTable({startY: 45,
                        tableLineColor: "blue",
                        tableLineWidth: 0.1,
                        styles: {
                          // font: 'Calibri',
                          fontSize: 9,
                          lineColor: "black",
                          lineWidth: 0.1
                        },
                        headStyles: {
                          fillColor: "#bdc3c7",
                          textColor: "black",
                          fontSize: 9
                        },
                        bodyStyles: {
                          fillColor: "#E9E4F0",
                          textColor: "black"
                        },
                        alternateRowStyles: {
                          fillColor: "white",
                          textColor: "black"
                        },
                        columnStyles: 
                        (this.props.permiteOpcion3||this.props.permiteOpcion4)?
                        {
                          7: {cellWidth: 20, halign: "right"},
                        }:
                        {
                          7: {cellWidth: 20, halign: "right"},
                          8: {cellWidth: 20, halign: "right"},
                        },
                        html: source,
                        margin: {top: 10, left: 2, right: 2}
        })
      }

      // let finalY = doc.previousAutoTable.finalY; //para traer posicion final de la tabla
      // doc.text("TOTAL", 50, finalY + 15);
      doc.autoPrint({variant: 'non-conform'});
      // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana

      let nameRte = 'reporte'
      if(this.props.permiteOpcion1){nameRte = "notdeb"}
      if(this.props.permiteOpcion2){nameRte = "notcre"}
      if(this.props.permiteOpcion3){nameRte = "ajupos"}
      if(this.props.permiteOpcion4){nameRte = "ajuneg"}
      doc.save(nameRte+'.pdf')
    }
    if(targetName==="excel"){
      let xlsString = []
      let listRtes = this.state.listRtes
// console.log(listRtes)
      let xlsString1 = []
      if((this.props.permiteOpcion1||this.props.permiteOpcion2)&&opciones==="opcion1"){
        xlsString1 = ['Fecha Nota', '# Nota', 'Contrato', 'Nombre(s)', 'Apellido(s)', '# Factura', 'Creada por', 'Observación',
          '$ antes imptos', '$ Total nota']
      }
      if((this.props.permiteOpcion1||this.props.permiteOpcion2)&&opciones==="opcion2"){
        xlsString1 = ['Fecha Nota', '# Nota', 'Contrato', 'Nombre(s)', 'Apellido(s)', '# Factura', 'Creada por',
          'Clase', 'Servicio', '$ antes imptos', '$ Imptos', '$ Total']
      }
      if((this.props.permiteOpcion3||this.props.permiteOpcion4)&&opciones==="opcion1"){
        xlsString1 = ['Fecha Ajuste', '# Ajuste', 'Contrato', 'Nombre(s)', 'Apellido(s)', 'Creada por',
          'Concepto', '$ Valor']
      }
      if(opciones==="opcion3"){
        if(this.props.permiteOpcion1||this.props.permiteOpcion2){
          xlsString1 = ['CONTRATO', 'TIPO DOCUM', 'No. DOCUM', 'APELLIDO(S)', 'NOMBRE(S)', 'RAZON SOCIAL', 'DIRECCION',
            'BARRIO', 'DPTO', 'CIUDAD', 'CLASE', 'ANTES DE IMPTOS', 'IMPUESTOS', 'TOTAL']
        }else{
          xlsString1 = ['CONTRATO', 'TIPO DOCUM', 'No. DOCUM', 'APELLIDO(S)', 'NOMBRE(S)', 'RAZON SOCIAL', 'DIRECCION',
            'BARRIO', 'DPTO', 'CIUDAD', 'ANTES DE IMPTOS', 'IMPUESTOS', 'TOTAL']
        }
      }

      xlsString.push(xlsString1)

      for(let i=0; i<listRtes.length; i++){
        let fechaNota = "", fechaAjuste = ""
        if(listRtes[i].fechaNota){
          fechaNota = new Date(listRtes[i].fechaNota)
          let horaPago = (fechaNota.getUTCHours()<10?'0'+fechaNota.getUTCHours():fechaNota.getUTCHours())+":"+(fechaNota.getUTCMinutes()<10?'0'+fechaNota.getUTCMinutes():fechaNota.getUTCMinutes())+":"+(fechaNota.getUTCSeconds()<10?'0'+fechaNota.getUTCSeconds():fechaNota.getUTCSeconds());
          fechaNota = (fechaNota.getUTCFullYear()) + '-' +
            ((fechaNota.getUTCMonth()+1)<10?'0'+(fechaNota.getUTCMonth()+1):(fechaNota.getUTCMonth()+1)) + '-' +
            (fechaNota.getUTCDate()<10?'0'+fechaNota.getUTCDate():fechaNota.getUTCDate())

          if(horaPago==="00:00:00"){
            fechaNota = new Date(fechaNota + 'T23:00:00.000Z')
          }else{
            fechaNota = new Date(fechaNota + 'T' + horaPago + 'Z')
          }
        }
        if(listRtes[i].fechaAjuste){
          fechaAjuste = new Date(listRtes[i].fechaAjuste)
          let horaPago = (fechaAjuste.getUTCHours()<10?'0'+fechaAjuste.getUTCHours():fechaAjuste.getUTCHours())+":"+(fechaAjuste.getUTCMinutes()<10?'0'+fechaAjuste.getUTCMinutes():fechaAjuste.getUTCMinutes())+":"+(fechaAjuste.getUTCSeconds()<10?'0'+fechaAjuste.getUTCSeconds():fechaAjuste.getUTCSeconds());
          fechaAjuste = (fechaAjuste.getUTCFullYear()) + '-' +
            ((fechaAjuste.getUTCMonth()+1)<10?'0'+(fechaAjuste.getUTCMonth()+1):(fechaAjuste.getUTCMonth()+1)) + '-' +
            (fechaAjuste.getUTCDate()<10?'0'+fechaAjuste.getUTCDate():fechaAjuste.getUTCDate())

          if(horaPago==="00:00:00"){
            fechaAjuste = new Date(fechaAjuste + 'T23:00:00.000Z')
          }else{
            fechaAjuste = new Date(fechaAjuste + 'T' + horaPago + 'Z')
          }
        }
        if(((this.props.permiteOpcion1||this.props.permiteOpcion2)&&opciones==="opcion1"&&listRtes[i].fechaNota!==undefined)||
          (listRtes[i].fechaNota!==undefined&&listRtes[i].fechaAjuste===undefined&&opciones==="opcion1")){
          xlsString1 = [fechaNota, listRtes[i].numeroNota, listRtes[i].contrato, listRtes[i].nombreCliente,
            listRtes[i].apellidoCliente, listRtes[i].numeroFra, listRtes[i].usuarioCreate, listRtes[i].observacNota, listRtes[i].valorAntesImptos, 
            listRtes[i].valorNota]
        }
        if(((this.props.permiteOpcion1||this.props.permiteOpcion2)&&opciones==="opcion2"&&listRtes[i].fechaNota!==undefined)||
            (listRtes[i].fechaNota!==undefined&&listRtes[i].fechaAjuste===undefined&&opciones==="opcion2")){
          let valorImptos = parseInt(listRtes[i].valorImptos, 10)
          let valorAntesImptos = parseInt(listRtes[i].valorAntesImptos, 10)
          let valorTotal = parseInt(listRtes[i].valorTotal, 10)
          xlsString1 = [fechaNota, listRtes[i].numeroNota, listRtes[i].contrato, listRtes[i].nombreCliente,
            listRtes[i].apellidoCliente, listRtes[i].numeroFra, listRtes[i].usuarioCreate, listRtes[i].descrClaseServ, 
            listRtes[i].descripcionServicio, valorAntesImptos, valorImptos, valorTotal]
        }
        if(((this.props.permiteOpcion3||this.props.permiteOpcion4)&&opciones==="opcion1"&&listRtes[i].fechaAjuste!==undefined)||
            (listRtes[i].fechaAjuste!==undefined&&listRtes[i].fechaNota===undefined)){
          xlsString1 = [fechaAjuste, listRtes[i].numeroAjuste, listRtes[i].contrato, listRtes[i].nombreCliente,
            listRtes[i].apellidoCliente, listRtes[i].usuarioCreate, listRtes[i].concepto, listRtes[i].valorAjuste]
        }
        if(opciones==="opcion3"){
          // let valorImptos = parseInt(listRtes[i].valorFacturado, 10) - parseInt(listRtes[i].valorAntesImptos, 10)
          // if(this.props.permiteOpcion3||this.props.permiteOpcion4){
          //   valorImptos = 0
          // }
          if(this.props.permiteOpcion1||this.props.permiteOpcion2){
            xlsString1 = [listRtes[i].contrato, listRtes[i].codigoTipoDoc, listRtes[i].numeroDoc,
              listRtes[i].apellidoCliente, listRtes[i].nombreCliente,
              listRtes[i].razonSocial, listRtes[i].direccionCli, listRtes[i].nombreBarrio, 
              listRtes[i].codigoDpto, listRtes[i].codigoCiudad, listRtes[i].descrClaseServ,
              listRtes[i].valorAntesImptos, listRtes[i].valorImptos, listRtes[i].valorFacturado]
          }else{
            xlsString1 = [listRtes[i].contrato, listRtes[i].codigoTipoDoc, listRtes[i].numeroDoc,
              listRtes[i].apellidoCliente, listRtes[i].nombreCliente,
              listRtes[i].razonSocial, listRtes[i].direccionCli, listRtes[i].nombreBarrio, 
              listRtes[i].codigoDpto, listRtes[i].codigoCiudad,
              listRtes[i].valorAntesImptos, listRtes[i].valorImptos, listRtes[i].valorFacturado]
          }
        }

    // console.log(xlsString1)
    xlsString.push(xlsString1)
  }
// console.log(xlsString)

  var wb = XLSX.utils.book_new();

  wb.Props = {
    Title: "SheetJS Tutorial",
    Subject: "Test",
    Author: "Red Stapler",
    CreatedDate: new Date(2017,12,19)
  };

  wb.SheetNames.push("Notaju");

  let ws_data = xlsString;

  let ws = XLSX.utils.aoa_to_sheet(ws_data);
  wb.Sheets["Notaju"] = ws;
  let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
  function s2ab(s) { 
    let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
    let view = new Uint8Array(buf);  //create uint8array as viewer
    for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
    return buf;    
  }
  saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'notaju.xlsx');
//FIN Exportar a XLS
    }
    document.body.style.cursor = 'default'
    // console.log("listooooo")
  }

  componentDidUpdate(prevProps){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.descrDpto!==this.state.argsDocum.descrDpto||
        this.props.argsSelDpto.nombreCiudad!==this.state.argsDocum.nombreCiudad){
      const argsDocum = this.state.argsDocum
      argsDocum.descrDpto = this.props.argsSelDpto.descrDpto
      argsDocum.nombreCiudad = this.props.argsSelDpto.nombreCiudad
      this.setState({argsDocum});
      this.setState({argsSelDpto: this.props.argsSelDpto})
      let listRtes = []
      this.setState({listRtes, totalNotAju: 0, totalNAValor: 0})
      this.setState({verEnPantalla: false})
    }

    // if(this.props.argsSelDpto!==prevProps.argsSelDpto){
    //   this.setState({argsSelDpto: this.props.argsSelDpto})
    // }
    let yaSetState = false
    if(this.props.permiteOpcion1!==prevProps.permiteOpcion1&&!yaSetState){
      let listRtes = []
      this.setState({listRtes})
      yaSetState = true
    }

    if(this.props.permiteOpcion2!==prevProps.permiteOpcion2&&!yaSetState){
      let listRtes = []
      this.setState({listRtes})
      yaSetState = true
    }

    if(this.props.permiteOpcion3!==prevProps.permiteOpcion3&&!yaSetState){
      let listRtes = []
      this.setState({listRtes})
      yaSetState = true
    }

    if(this.props.permiteOpcion4!==prevProps.permiteOpcion4&&!yaSetState){
      let listRtes = []
      this.setState({listRtes})
      yaSetState = true
    }


    if(((this.props.permiteOpcion1||this.props.permiteOpcion2)&&
    (prevProps.permiteOpcion3||prevProps.permiteOpcion4))||
    ((this.props.permiteOpcion3||this.props.permiteOpcion4)&&
    (prevProps.permiteOpcion1||prevProps.permiteOpcion2))){
      this.setState({opciones: "opcion1"})
    }

  }

  componentWillUnmount(){
    let listRtes = []
    this.setState({listRtes, totPag: 0, valorTot: 0})
    this.setState({verEnPantalla: false})
  }
  
  render(){
    const {argsDocum, opciones, listRtes, confirmaAct, errors, totalNotAju, totalNAValor, verEnPantalla} = this.state;

    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selciudad(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu

    // let fechaHoy = new Date()
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

// console.log(this.props.allClientes.allClientes)
    // console.log(this.props.allNotasDebCreRtes.allNotasDebCreRtes)
// console.log(this.props.list1)
// console.log(argsDocum)
// console.log(opciones)

// let valorTotal = Intl.NumberFormat().format(valorTot)
// let totalPagos = Intl.NumberFormat().format(totPag)

// console.log(argsDocum._id)
// console.log(this.props.permiteOpcion1, this.props.permiteOpcion2, this.props.permiteOpcion3, this.props.permiteOpcion4)
let titOpcion = ""
if(this.props.permiteOpcion1){titOpcion = "Notas débito"}
if(this.props.permiteOpcion2){titOpcion = "Notas crédito"}
if(this.props.permiteOpcion3){titOpcion = "Ajustes positivos"}
if(this.props.permiteOpcion4){titOpcion = "Ajustes negativos"}

let totalNotAju1 = Intl.NumberFormat('de-DE').format(totalNotAju)
let totalNAValor1 = Intl.NumberFormat('de-DE').format(totalNAValor)
if(listRtes.length===0){
  totalNotAju1 = 0
  totalNAValor1 = 0
}

// console.log(listRtes)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large money yellow icon"></i>
          {titOpcion}
        </button>

        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, argsDocum, opciones):()=>{}}>
              <div>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <h1 style={{color: '#2C7744'}}>{titOpcion}</h1>
                    </div>
                    {(this.props.permiteOpcion1||this.props.permiteOpcion2) &&
                      <div className="column" style={{width: '50%'}}>
                        <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Causado en&nbsp;&nbsp;&nbsp;</legend>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion1" defaultChecked="true" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;General&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion2" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Detallado&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion3" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Total por contrato</label>
                        </fieldset>
                      </div>
                    }
                    {(this.props.permiteOpcion3||this.props.permiteOpcion4) &&
                      <div className="column" style={{width: '50%'}}>
                        <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Causado en&nbsp;&nbsp;&nbsp;</legend>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion1" defaultChecked="true" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;General&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                          <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion3" onChange={this.handleChange}></input>
                          <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Total por contrato</label>
                        </fieldset>
                      </div>
                    }
                  </div>
                </div>
                <hr></hr> 
                <div className="ui three column stackable grid">
                  <div className="row container">
                    {(this.props.permiteOpcion1||this.props.permiteOpcion2) &&
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Rango de facturación
                      </p>
                      <Form.Field>
                        <ListaRango styles={this.props.styles} list={this.props.list} handleChange={this.handleChange} />
                      </Form.Field>
                    </div>
                    }
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Desde
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Hasta
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>

                  </div>
                </div>
                <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Departamento
                      </p>
                      <Form.Field>
                        <ListaDe list={this.props.list1} styles={this.props.styles}
                            handleLista={this.props.handleLista}
                            codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Ciudad
                      </p>
                      <Form.Field>
                        <ListaCi list={listCiu} styles={this.props.styles}
                          handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                          codigoCiudadUA={this.props.codigoCiudadUA}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                {(opciones==="opcion2") &&
                  <div>
                    <hr></hr>
                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Clase
                    </p>
                    <Form.Field>
                      <Lista styles={this.props.styles} list={this.props.list2} handleLista4={this.props.handleLista4}
                      argsSelDpto={this.props.argsSelDpto} handleChange={this.handleChange}/>
                    </Form.Field>
                  </div>
                }
                <hr></hr>
                <hr></hr>

                {opciones!=="opcion3" &&
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Totales:  {titOpcion}:&nbsp;
                    {totalNotAju1}&nbsp;&nbsp;&nbsp;&nbsp;
                    Valor:&nbsp;
                    {totalNAValor1}&nbsp;&nbsp;&nbsp;&nbsp;
                  </p>
                }
                {opciones==="opcion3" &&
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Total:  {titOpcion}:&nbsp;
                    {totalNAValor1}&nbsp;&nbsp;&nbsp;&nbsp;
                  </p>
                }

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '34%'}}>
                      <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones)} fluid>
                        VER EN PANTALLA
                      </Button>
                    </div>
                    <div className="column" style={{width: '33%'}}>
                      <Button id="pantalla" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones)} fluid>
                        ARCHIVO EXCEL
                      </Button>
                    </div>
                    <div className="column" style={{width: '33%'}}>
                      <Button id="pantalla" name="pdf" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones)} fluid>
                        ARCHIVO PDF
                      </Button>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div style={{height: '40em', overflow: 'auto'}}>

                {(((this.props.permiteOpcion1||this.props.permiteOpcion2)&&opciones==="opcion1")&&opciones!=="opcion3") &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className='right aligned'>Fecha Nota</th>
                        <th className='right aligned'># Nota</th>
                        <th className='right aligned'>Contrato</th>
                        <th className='right aligned'>Nombre</th>
                        <th className='right aligned'>Apellido</th>
                        <th className='right aligned'># Factura</th>
                        <th className='right aligned'>Creada por</th>
                        <th className='right aligned'>Observación</th>
                        <th className='right aligned'>$ antes imptos</th>
                        <th className='right aligned'>$ Total nota</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaNotAju list={listRtes} opciones={opciones}
                        permiteOpcion1={this.props.permiteOpcion1} permiteOpcion2={this.props.permiteOpcion2}
                        permiteOpcion3={this.props.permiteOpcion3} permiteOpcion4={this.props.permiteOpcion4}/>
                    }
                  </table>
                }
                {(((this.props.permiteOpcion1||this.props.permiteOpcion2)&&opciones==="opcion2")&&opciones!=="opcion3") &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className='right aligned'>Fecha Nota</th>
                        <th className='right aligned'># Nota</th>
                        <th className='right aligned'>Contrato</th>
                        <th className='right aligned'>Nombre</th>
                        <th className='right aligned'>Apellido</th>
                        <th className='right aligned'># Factura</th>
                        <th className='right aligned'>Creada por</th>
                        <th className='right aligned'>Clase</th>
                        <th className='right aligned'>Servicio</th>
                        <th className='right aligned'>$ antes imptos</th>
                        <th className='right aligned'>$ imptos</th>
                        <th className='right aligned'>$ total</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaNotAju list={listRtes} opciones={opciones}
                        permiteOpcion1={this.props.permiteOpcion1} permiteOpcion2={this.props.permiteOpcion2}
                        permiteOpcion3={this.props.permiteOpcion3} permiteOpcion4={this.props.permiteOpcion4}/>
                    }
                  </table>
                }
                {(((this.props.permiteOpcion3||this.props.permiteOpcion4)&&opciones==="opcion1")&&opciones!=="opcion3") &&

                // {((this.props.permiteOpcion3||this.props.permiteOpcion4)&&opciones!=="opcion3") &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className='right aligned'>Fecha Ajuste</th>
                        <th className='right aligned'># Ajuste</th>
                        <th className='right aligned'>Contrato</th>
                        <th className='right aligned'>Nombre</th>
                        <th className='right aligned'>Apellido</th>
                        <th className='right aligned'>Creada por</th>
                        <th className='right aligned'>Concepto</th>
                        <th className='right aligned'>$ Valor</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaNotAju list={listRtes} opciones={opciones}
                        permiteOpcion1={this.props.permiteOpcion1} permiteOpcion2={this.props.permiteOpcion2}
                        permiteOpcion3={this.props.permiteOpcion3} permiteOpcion4={this.props.permiteOpcion4}/>
                    }
                  </table>
                }
                {((this.props.permiteOpcion1||this.props.permiteOpcion2)&&opciones==="opcion3") &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>CONTRATO</th>
                        <th className=''>TIPO DOCUM</th>
                        <th className=''>No. DOCUM</th>
                        <th className=''>APELLIDO(S)</th>
                        <th className=''>NOMBRE(S)</th>
                        <th className=''>RAZON SOCIAL</th>
                        <th className=''>DIRECCION</th>
                        <th className=''>BARRIO</th>
                        <th className=''>DPTO</th>
                        <th className=''>CIUDAD</th>
                        <th className=''>CLASE</th>
                        <th className='right aligned'>ANTES DE IMPTOS</th>
                        <th className='right aligned'>IMPUESTOS</th>
                        <th className='right aligned'>TOTAL</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaNotAju list={listRtes} opciones={opciones}
                      permiteOpcion1={this.props.permiteOpcion1} permiteOpcion2={this.props.permiteOpcion2}
                      permiteOpcion3={this.props.permiteOpcion3} permiteOpcion4={this.props.permiteOpcion4}/>
                    }
                  </table>
                }
                {((this.props.permiteOpcion3||this.props.permiteOpcion4)&&opciones==="opcion3") &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>CONTRATO</th>
                        <th className=''>TIPO DOCUM</th>
                        <th className=''>No. DOCUM</th>
                        <th className=''>APELLIDO(S)</th>
                        <th className=''>NOMBRE(S)</th>
                        <th className=''>RAZON SOCIAL</th>
                        <th className=''>DIRECCION</th>
                        <th className=''>BARRIO</th>
                        <th className=''>DPTO</th>
                        <th className=''>CIUDAD</th>
                        <th className='right aligned'>ANTES DE IMPTOS</th>
                        <th className='right aligned'>IMPUESTOS</th>
                        <th className='right aligned'>TOTAL</th>
                      </tr>
                    </thead>
                    {verEnPantalla &&
                      <ListaNotAju list={listRtes} opciones={opciones}
                      permiteOpcion1={this.props.permiteOpcion1} permiteOpcion2={this.props.permiteOpcion2}
                      permiteOpcion3={this.props.permiteOpcion3} permiteOpcion4={this.props.permiteOpcion4}/>
                    }
                  </table>
                }
                </div>
              </div>
              
              {
                errors.length?<Message negative header="Los siguientes errores:"
                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
              }

            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allNotasDCRtes, {name:'allNotasDCRtes', options: (props) => {return {variables: argsBuscarNot}}}),
  graphql(queries.query.allAjusteRtes, {name:'allAjusteRtes', options: (props) => {return {variables: argsBuscarAju}}}),
  graphql(queries.query.allNotasDebCreRtes, {name:'allNotasDebCreRtes', options: (props) => {return {variables: argsBuscarNot}}}),
  )(RtesNotAju2)
